var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"app"},[(_vm.config && _vm.layout)?_c(_vm.layout,{tag:"component"}):_c('error',{attrs:{"status":500}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }